import eventEmitter from './eventemitter';

export const events = {
    PRODUCT_SELECT: 'select',
    PRODUCT_DESELECT: 'deselect'
};

export default function productGrid($container, products, MAX_PRODUCT_COUNT) {
    const emitter = eventEmitter();
    const CHECKBOX_ID_PREFIX = 'cbProductClass_';
    const findById = id => $container.querySelector(`#${CHECKBOX_ID_PREFIX}${id}`);
    const $checkboxes = Array.from($container.querySelectorAll(`input[type=checkbox][id*=${CHECKBOX_ID_PREFIX}]`));

    const setCheckedState = state => product => {
        const $check = findById(product.id);

        if (!$check) {
            return;
        }

        $check.checked = state;
    };

    const select = setCheckedState(true);

    const deselect = setCheckedState(false);

    const handleClick = $checkbox => {
        emitter.emit(
            $checkbox.checked ? events.PRODUCT_SELECT : events.PRODUCT_DESELECT,
            getProductDataFromCheck($checkbox)
        );
    };

    let isLocked = false;

    const lock = () => {
        $checkboxes
            .filter($box => !$box.checked)
            .forEach($box => {
                $box.disabled = true;
                $box.parentElement.parentElement.insertAdjacentHTML(
                    'afterend',
                    '<div class="product-compare fullQueueMsg msgLive noClick">Your Compare Queue is Full</div>'
                );
            });
        isLocked = true;
    };

    const unlock = () => {
        $checkboxes
            .filter($box => $box.disabled)
            .forEach($box => {
                $box.disabled = false;
                const $element = $box.parentElement.parentElement.nextElementSibling;
                $element.parentElement.removeChild($box.parentElement.parentElement.nextElementSibling);
            });
        isLocked = false;
    };

    $checkboxes.forEach($check => {
        $check.parentElement.parentElement.style.opacity = 1;
        $check.disabled = false;
        $check.addEventListener('click', event => handleClick(event.currentTarget));
    });

    if (Array.isArray(products)) {
        products.forEach(product => select(product));

        if (products.length >= MAX_PRODUCT_COUNT) {
            lock();
        }
    }

    return {
        ...emitter,
        select,
        deselect,
        deselectAll: () => {
            unlock();
            $checkboxes.forEach($box => ($box.checked = false));
        },
        lock,
        unlock,
        isLocked: () => {
            return isLocked;
        }
    };
}

export function getProductDataFromCheck($checkbox) {
    const $parent = $checkbox.closest('.productBg');

    if (!$parent) {
        return null;
    }

    const $img = $parent.querySelector('img');

    if (!$img) {
        return null;
    }

    return {
        id: +$checkbox.value,
        img: $img.src.split('?')[0],
        name: $img.alt
    };
}
